import { cls, marketUrl } from "@/utils/util";
import { NavLink } from "react-router-dom";
import FooterFlag from "@/component/FooterFlag";

const menuItems = [
  {
    title: "홈",
    icon: "ii ii-home-outline",
    path: "/",
  },
  {
    title: "클래스",
    icon: "ii ii-user-screen-outline",
    path: "/class",
    badge: <FooterFlag value="class" />,
  },
  {
    title: "마켓",
    icon: "ii ii-cart-outline",
    path: marketUrl("/market"),
    badge: <FooterFlag value="market" />,
  },
  {
    title: "게시판",
    icon: "ii ii-document-with-lines-outline",
    path: "/post",
  },
  {
    title: "Q&A/임상",
    icon: "ii ii-message-outline",
    path: "/qna",
  },
];

const BottomNavigation = () => {
  return (
    <div className="block lg:hidden">
      <menu className="fixed bottom-0 left-0 right-0 z-20 border-t bg-base border-base">
        <ul className="flex justify-evenly w-full">
          {menuItems.map((menuItem) => {
            const isExternal = menuItem.path.startsWith("http");
            return (
              <li
                className="relative flex-1 flex flex-col items-center py-2.5"
                key={menuItem.title}
              >
                {menuItem.badge}
                <NavLink
                  to={menuItem.path}
                  end
                  className={({ isActive }) => {
                    return cls(
                      isActive && !isExternal ? "!text-primary" : "text-secondary",
                      "text-[10px] text-center",
                    );
                  }}
                >
                  <i className={cls(menuItem.icon, "block text-2xl text-inherit")}></i>
                  {menuItem.title}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </menu>
    </div>
  );
};

export default BottomNavigation;
